import './index.scss'
import moment from "moment";

const Agreement = ({ data }: { data: any }) => {

  return <div className='signAContract Agreement'>
    <h2>《摩托车融资租赁合同（售后回租）》的补充协议</h2>
    <div>尊敬的<ins>{data?.fullName}</ins>（身份证号：<ins>{data?.identityCard}</ins>）先生/女士：</div>
    <div className='texindent'>根据您所提出变更承租人扣款账户的申请，我司现与您签订关于《摩托车融资租赁合同（售后回租）》的补充协议，原《摩托车融资租赁合同（售后回租）》合同号：<ins>{data?.contractNo}</ins>中承租人扣款账户为<ins>{data?.oldBankCard}</ins> 现变更为<ins>{data?.newBankCard}</ins>。</div>
    <div className='right'>润雨同舟（深圳）融资租赁有限公司</div>
    <div className='riqi'>{moment(new Date()).format('YYYY 年 MM 月 DD 日')}</div>
  </div>
}

export default () => {
  return <Agreement data={{}}></Agreement>
}